
      import API from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/@rsbuild/core/compiled/style-loader/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/@rsbuild/core/compiled/css-loader/index.js??clonedRuleSet-29.use[1]!../../../node_modules/@rsbuild/plugin-vue/node_modules/vue-loader/dist/stylePostLoader.js!../../../node_modules/@rsbuild/plugin-sass/compiled/sass-loader/index.js??clonedRuleSet-29.use[2]!../../../node_modules/@rsbuild/plugin-vue/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./_unauthorized.vue?vue&type=style&index=0&id=80ba2056&lang=scss&module=true";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/@rsbuild/core/compiled/css-loader/index.js??clonedRuleSet-29.use[1]!../../../node_modules/@rsbuild/plugin-vue/node_modules/vue-loader/dist/stylePostLoader.js!../../../node_modules/@rsbuild/plugin-sass/compiled/sass-loader/index.js??clonedRuleSet-29.use[2]!../../../node_modules/@rsbuild/plugin-vue/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./_unauthorized.vue?vue&type=style&index=0&id=80ba2056&lang=scss&module=true";
       export default content && content.locals ? content.locals : undefined;
